import { toast } from '../components/Toaster';

/**
 * Copy text; falls back to execCommand where the Clipboard API is unavailable (plain HTTP, sandboxed frames).
 * With `announce`, a toast confirms it. A failure always explains how to copy by hand.
 */
export async function copyText(text: string, announce?: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const area = Object.assign(document.createElement('textarea'), { value: text });
    area.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
    document.body.append(area);
    area.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }
    area.remove();
    if (!ok) {
      toast("Couldn't copy automatically", { description: 'Select the text and copy it with ⌘C or Ctrl+C.', tone: 'warning' });
      return false;
    }
  }
  if (announce) toast(announce, { tone: 'success', duration: 2600, haptic: false });
  return true;
}
